import { filter, find, findIndex, isString, map, sortBy, uniq } from 'es-toolkit/compat';

import { FeatureMetadata, ResultOverlaySection } from './featureMetadata';

const nucleaiSegmentationDefaultColor = '#FFFF00';
const dilationSegmentationDefaultColors = ['#FF0000', '#00FF00', '#00B3B3', '#002DB3', '#FF00FF', '#FF7600'];

export const getSegmentationDefaultColor = (heatmap: FeatureMetadata, pmtHeatmaps: FeatureMetadata[]) => {
  if (heatmap.overlaySection !== ResultOverlaySection.CellSegmentation) {
    return undefined;
  }
  if (heatmap.segmentationDilation === undefined) {
    return nucleaiSegmentationDefaultColor;
  }

  const dilationDistances = sortBy(
    uniq(
      map(
        filter(
          pmtHeatmaps,
          (candidate) =>
            candidate.overlaySection === ResultOverlaySection.CellSegmentation &&
            candidate.segmentationDilation !== undefined
        ),
        'segmentationDilation'
      )
    )
  );
  const dilationIndex = findIndex(dilationDistances, (distance) => distance === heatmap.segmentationDilation);
  if (dilationIndex < 0) {
    return dilationSegmentationDefaultColors[0];
  }
  return dilationSegmentationDefaultColors[dilationIndex % dilationSegmentationDefaultColors.length];
};

export const getSegmentationLayerDefaultColor = (
  heatmap: FeatureMetadata,
  pmtHeatmaps: FeatureMetadata[],
  layerName?: string
) => {
  if (heatmap.overlaySection !== ResultOverlaySection.CellSegmentation) {
    return undefined;
  }

  const optionColor = find(heatmap.options, { key: layerName })?.color;
  return layerName !== 'cell' && isString(optionColor)
    ? optionColor
    : getSegmentationDefaultColor(heatmap, pmtHeatmaps);
};
